
@if (headingHtml) {
  <h2 [innerHTML]="headingHtml"></h2>
}

<div class="dynamic-links-container">

  @for (link of linkArray; track link) {
    <div class="dynamic-link {{'layout-' + linksPerRow}}">
      <div class="description" [innerHTML]="link.descriptionHtml || '&nbsp;'"></div>
      <div [class]="link.linkType">
        @if (link.url) {
          <a [href]="link.url" [target]="link.isNewTab == 'true' ? '_blank' : '_self'">{{link.label}}</a>
        }
      </div>
      @if (!link.url) {
        <app-sso-handler [ssoLabel]="link.label" [ssoType]="link.ssoType" [linkType]="link.linkType"></app-sso-handler>
      }
    </div>
  }
</div>